import { serializeError } from 'serialize-error'

/**
 * @deprecated Use ./client/utils/logger.ts instead
 */
const loggingService = (
	message: string,
	error: Error,
	extraInfo: { [key: string]: number | string }
): void => {
	if (typeof window !== 'undefined' && window.newrelic) {
		const serializedError = serializeError(error)
		window.newrelic.noticeError(message, {
			errorName: serializedError.name || 'n/a',
			errorMessage: serializedError.message || 'n/a',
			errorStack: serializedError.stack || 'n/a',
			...extraInfo,
		})
	}
}

export default loggingService
